import { createContext } from 'react';

import { Context } from '../../../types';
import { AgentCommissionAccount } from '../model';
import api from '../api';
import { getContextDefaultValues } from '../../providersDataManager';

export default createContext<Context<AgentCommissionAccount>>(getContextDefaultValues(api));
